export default {
  errors: {
    wrong_brn_format: "Wrong BRN format",
    db_query_failed: "Error database connection",
    db_fetch_failed: "Error reading from the database",
    permission_denied: "You do not have permission to use this system",
    // msw: "Error MSW API connection",
    msw_unknown_result: "Error reading from MSW API",
    invalid_param: "The parameter provided is incorrect.",
    msw: {
      numberblock_add_failed : "Create Number Block failed",
      number_create_failed :"Could not add this phone number to the system",
      number_delete_failed :"Could not delete this phone number from the system",
    },
    dtac: {
      idcard_validate_fail: "This BRN could not be found",
      subs_query_status_failed: "This phone number cannot be found on dtac's system.",
      subs_query_package_failed: "No information of this package was found on dtac's system.",
      wci_failed: "Could not create or add this phone number.",
      unknown_result: "Error reading from DTAC API",
      wci_queue: "Creating number in queue"
    },
    user: {
      duplicate: "Duplicate User information",
      duplicate_username: "Duplicate Username information",
      duplicate_email: "Duplicate email information",
      blcok_delete_by_self: "Can't delete data by yourself.",
      fail: "Error update user information",
      email_wrong_format: "Wrong email format",
      enterprise_empty: "Please select Enterprise",
    },
    corp: {
      duplicate: "Duplicate Corporate information",
      not_exist: "Organization information not found",
      check_number_fail: "The number checking is fail.",
      number_exist: "Error found number in Corporate",
      failed: "Error update Corporate information",
      create_failed: "Error create Corporate information",
      delete_failed: "Error delete Corporate information",
      user_exist : "Error found user in Corporate",
    },
    mlhg: {
      duplicate: "Duplicate Muti-line Hunting Group information",
      get_dummy_number_fail: "Information for dummy number for MLHG is not found",
      not_exist: "Not found this MLHG Information",
      member_not_exist: "Not found this number in this MLHG",
      member_not_in_corp: "Not found this number in this Enterprise",
      get_enterprise_fail: "Not found this Corporate",
      get_mlhg_fail: "Not found this MLHG",
      get_number_fail: "Not found this Number",
      get_pilot_fail: "Not found this Company Number",
      update_number_fail: "Update number in this MLHG failed",
      delete_number_fail: "Delete number in this MLHG failed",
      redeem_dummy_pilot_failed: "Cannot redeem dummy number",
      number_duplicate: "This number is duplicate in this MLHG"
    },
    auth: {
      login_fail: "Login Fail",
      block: "User has been blocked",
      login_success: "Login Success",
      logout_success: "Log out Success",
      unauthoriezed: "No permission",
      reset_invalid_token: "token invalid",
      reset_token_expired: "token reset_token_expired",
      forgot_password_fail: "forgot password failed",
      reset_password_fail: "reset password failed",
      username_wrong_format: "Wrong username format",
      password_wrong_format: "Wrong password format",
      token: "Invalid Token",
      password: "Invalid password",
      password_confirm: "Invalid confirm password",
    },
    package: {
      duplicate_code: "Package Code is Duplicate",
      duplicate_name: "Package Name is Duplicate",
      not_exist: "not found package information",
      delete_lock: "Cannot delete this package Because it is in use",
      get_profile_failed: "The VPBX package could not be found in the system."
    },
    subs: {
      not_exist: "This Number not exist",
      corp_not_match: "Corporate information not match",
      get_crop_id_failed: "Not found Corporate information or Company Number",
      comp_login_failed: "Cannot login to ComPortal",
      duplicate: "Duplicate Number",
      get_charge_number_failed: "Could not find telephone number information under this company.",
      set_charge_number_failed: " This phone number cannot be changed.",
      get_brn_failed: "Not found this BRN",
      is_mlhg_member: "This number is member of MLHG",
      number_range_delete_fail: "Cannot delete Number Range",
      comp_login_failed: "Error Login to ComPortal",
      subs_status_failed: "This Number is not eligible to subscribe this service",
      import: "Import number failed",
      reset_password_fail: "Reset password failed",
      delete_failed: "Delete number failed",
      delete_number_block_failed: "Delete Number Block failed",
    },
    profile : {
      change_profile_failed : "Change profile failed",
      change_password_failed : "Change password failed",
      password_confirm_not_match: "Error confirm password",
      password_confirm_wrong_format: "Wrogn password format.",
      password_old_wrong : "Wrong old password",

    }
  },

  bc_portal: "Web Portal",
  bc_package: "Package",
  bc_voicemail: "Voice Mail",
  bc_report: "Record Detail",
  bc_user: "User",
  bc_corporate: "Corporate",
  bc_mlhg: "Hunt Group",
  bc_pilot_number: "Company Number",
  bc_agent_number: "User Number",
  bc_change_profile: "Edit Profile",
  bc_change_password: "Edit Password",



  profile: {
    profile: "Profile",
    name: "Name",
    phone: "Phone",
    email: "E-Mail",
    change_password: "Change Password",
    password_old: "Old Password",
    password_new: "New Password",
    password_confirm: "Confirm Password",
    change_profile_success : "Change profile successed",
    change_password_success : "Change password successed",
    forgot_password_success : "Forgot password successed , Please check your email.",
    reset_password_success : "Reset password successed",
  },
  menu: {
    corporate: "Corporate",
    mlhg: "Hunt Group",
    package: "Package",
    pilot_number: "Company Number",
    agent_number: "User Number",
    number: "Number",
    user: "User",
    voicemail: "Voice Mail",
    cdr: "Record Detail",
    nseries: "Voice Conference",
    inventory: "Inventory",
    partner: "Partner",
    product: "Product",
    storage: "Storage"
  },
  auth: {
    signin: "Sign In",
    signout: "Logout",
    username: "E-Mail or Number",
    email: "E-Mail",
    password: "Password",
    forgetpassword: "Forgot Password",
    resetpassword: "Reset Password"
  },
  corp: {
    name: "Corporate",
    brn: "BRN",
    code: "Code",
    create: "Create Corporate",
    create_success: "Successfully created the corporate",
    create_fail: "Failed to create corporate"
  },
  package: {
    name: "Package",
    code: "Package Code",
    create: "Create Package",
    profile: "Persistent Profile",
    cos: "Class Of Service",
    create_success: "Successfully created the package",
    create_fail: "Failed to create package"
  },
  number: {
    add: "Add Number",
    pilot: "Company Number",
    agent: "User Number",
    charge: "Charge Number",
    syncpackage: "Sync Package for all",
    create_success: "Successfully created the Number",
    agent_create: "Create User Number",
    pilot_create: "Create Company Number",
    pilot_create_success: "Successfully created the Company Number",
    pilot_create_fail: "Failed to create the Company Number",
    agent_create_success: "Successfully created the User Number",
    agent_create_fail: "Failed to create the User Number",
    bgadmin_login_fail: "Login BG Admin Failed",
    comportal_login_fail: "Login Comm Portal Failed",
    sync_package_success: "Sync package successed"
  },
  voicemail: {
    name: "Voice Mail",
    to: "to",
    from: "from",
    date: "date",
    corp: "Corporate"
  },
  report: {
    menu: "Record Detail",
    type: "Record Type",
    start: "Start",
    end: "End",
    duration: "Duration",
    corp: "Corporate"
  },
  user: {
    create: "Create User",
    name: "Name",
    username: "Username",
    type: "Type",
    phone: "Phone",
    role: "Role",
    create_success: "Create User successed",
    create_fail: "Create User failed"
  },
  mlhg: {
    name: "Hunt Group",
    failed: "Hunt Group failed",
    success: "Hunt Group successed"
  },

  group_name: "Group Name",
  email: "E-Mail",
  email_optional: "E-Mail (Optional)",
  created: "Created",
  search: "Search",
  save: "Save",
  back: "Back",
  new: "New",
  status: "Status",
  download: "Download",
  downloadall: "Download All",
  search: "Search",
  welcome: "Welcome",
  myprofile: "Profile",
  changepassword: "Change Password",
  page_notfound: "Sorry Page not found.",
  page_notfound_desc: "Plase check URL again.",
  actions: "Menu",
  data: "Data ",
  to: "To",
  of: "Of",
  row_select: "rows selected",
  yes: "Yes",
  no: "No",
  ok: "Ok",
  cancel: "Cancel",
  upload_file: "Upload File",
  bg_admin: "Admin Setting",
  comportal: "Agent Setting",
  add: "Add",
  close: "Close",
  please_select: "Please select..",
  create: "Create",
  confirm: "Confirm",
  create_success: "Create success",
  delete_confirm: "Confirm delete",
  delete_confirm_text: "Please confirm delete ",
  delete_confirm_question: "Do you want to delete this information ? ",
  delete_success: "Delete successed",
  delete_fail: "Delete Failed",
  edit_success: "Editing successed",
  edit_fail: "Editing failed"
};
